import React from 'react';

const Headline = ({headline, id}) => (
    <h2 style={{marginTop: "62px"}} id={id}>{headline}</h2>
)

export default Headline;